import React from "react";
import { ProductCard, MaterialCard, ContentCard } from "./SearchCard";
import ProductPatentCard from "./ProductPatentCard";
import { CONTENT_TYPES } from "./searchConstants";
import { DISPLAYMODE } from "./SearchToolbar/DisplayMode";
import { sortCuratedListingAlpha } from "./searchUtils";
import { SORT_OPTION, CONTENT_TYPE } from "../Global/GlobalConstants";

const {
  PRODUCT,
  PRODUCT_FAMILY,
  MATERIAL,
  ARTICLE,
  MEDIA,
  DOCUMENT,
  WEBPAGE,
  PATENT_FS,
  PATENT_RETAIL,
} = CONTENT_TYPES;

const { CURATEDLISTING } = CONTENT_TYPE;

/**
 * Component responsible for rendering search results based on content type
 */
function SearchResultRenderer({
  renderedSearchResults,
  contentType,
  sortValue,
  numberToShow,
  displayMode,
  modalContainerRef,
  positionModal,
  productHeight,
  productWidth,
  isSingleTypeSearch,
}) {
  if (!renderedSearchResults || renderedSearchResults.length === 0) {
    return null;
  }

  let localArray = [...renderedSearchResults];

  // Check for frontend sort for curated listing
  if (contentType === CURATEDLISTING) {
    if (sortValue?.toLowerCase() === SORT_OPTION.ALPHABETICAL) {
      localArray = sortCuratedListingAlpha(localArray);
    }
    localArray = localArray.slice(0, numberToShow);
  }

  const results = localArray
    .map((item, index) => {
      if (!item) return null;

      const key = `search-result-${index}`;

      switch (item.contentType) {
        case MATERIAL:
          return (
            <li key={key} className="search__results-list-item">
              <MaterialCard
                materialType={item}
                displayMode={displayMode}
                externalModalDiv={
                  displayMode === DISPLAYMODE.GRIDCOMPACT ? modalContainerRef.current : null
                }
                positionModal={positionModal}
              />
            </li>
          );

        case DOCUMENT:
        case ARTICLE:
        case MEDIA:
        case WEBPAGE:
          return (
            <li
              key={key}
              className={`search__results-list-item${
                item.contentType === DOCUMENT && isSingleTypeSearch ? "document" : ""
              }`}
            >
              <ContentCard
                isSingleTypeSearch={isSingleTypeSearch}
                result={item}
                displayMode={displayMode}
              />
            </li>
          );

        case PATENT_FS:
        case PATENT_RETAIL:
          return (
            <li key={key} className="search__results-list-item">
              <ProductPatentCard
                product={item}
                productImageHeight={productHeight}
                productImageWidth={productWidth}
              />
            </li>
          );

        case PRODUCT:
        case PRODUCT_FAMILY:
        default:
          if (item.contentType === PRODUCT || item.contentType === PRODUCT_FAMILY) {
            return (
              <li key={key} className="search__results-list-item">
                <ProductCard
                  product={item}
                  productImageHeight={productHeight}
                  productImageWidth={productWidth}
                  displayMode={displayMode}
                  externalModalDiv={
                    displayMode === DISPLAYMODE.GRIDCOMPACT ? modalContainerRef.current : null
                  }
                  positionModal={positionModal}
                />
              </li>
            );
          }
          return null;
      }
    })
    .filter((listitem) => listitem);

  return <>{results}</>;
}

export default SearchResultRenderer;
